/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
	getDevices,
	getDevice,
	printDevice,
	createDevices,
	updateDevices,
	deleteDevices,
	getDeviceTypes,
	getSignalStrengthGraph,
	getPortHistoryGraph,
	attachDeviceTag,
	deleteDeviceTag,
	attachNewDeviceTag,
	createDeviceBulk,
	getBatteryGraph,
	reprovisionDevice,
	updateDevicePort,
	createDevicePort,
	createDevicePortTank,
	updateDevicePortTank,
	deleteDevicePortTank,
	deleteDevicePort,
	getTemperatureGraph,
	createProductMove,
	getLT14DeviceLogs,
	getDeviceUsers,
	getDevicesForMap,
	getMobileProviders,
	getTankManufacturerSpecs,
} from "Modules/devices/config/api.devices";

const state = {
	page: {},
	offline_devices_page: {},
	device_alerts_page: {},
	lt14_device_log_page: {},
	form: {},
	devices: [],
	device_types: [],
	device_options: [],
	device_alerts: [],
	offline_devices: [],
	lt14_device_logs: [],
	selectedDevice: {
		device_id: null,
		company_id: "",
		device_date: "",
		reference_number: "",
		status_id: "",
		billing_address_id: "",
		shipping_address_id: "",
		comments: "",
		device_details: [],
	},
	devices_filter: {
		search: "",
		status: "active",
		company_id: null,
		device_type_id: null,
		tags: [],
		page_size: 0,
		page_num: 0,
		connection_status: "",
	},
	dashboard_offline_devices_page_num: 1,
	dashboard_device_alerts_page_num: 1,
	mobile_provider_options: [],
	mobile_providers: [],
	rules_devices: {
		device_id: {
			name: "device_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		public_id: {
			name: "public_id",
			rules: "trim|max_length[36]|is_unique[iot_devices.public_id]|required",
			max_len: "36",
			min_len: "",
			default_value: "",
		},
		company_id: {
			name: "company_id",
			rules: "trim|max_length[15]|integer",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		label: {
			name: "label",
			rules: "trim|max_length[65]",
			max_len: "65",
			min_len: "",
			default_value: "",
		},
		imei: {
			name: "imei",
			rules: "trim|max_length[30]",
			max_len: "30",
			min_len: "",
			default_value: "",
		},
		sim: {
			name: "sim",
			rules: "trim|max_length[30]",
			max_len: "30",
			min_len: "",
			default_value: "",
		},
		mobile_provider_id: {
			name: "mobile_provider_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		hologram_device_id: {
			name: "hologram_device_id",
			rules: "trim|max_length[36]|integer",
			max_len: "36",
			min_len: "",
			default_value: "",
		},
		hologram_link_id: {
			name: "hologram_link_id",
			rules: "trim|max_length[36]|integer",
			max_len: "36",
			min_len: "",
			default_value: "",
		},
		sim_state: {
			name: "sim_state",
			rules: "trim|max_length[14]",
			max_len: "14",
			min_len: "",
			default_value: "",
		},
		firmware_version_id: {
			name: "firmware_version_id",
			rules: "trim|max_length[15]|integer",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		ip_address: {
			name: "ip_address",
			rules: "trim|max_length[39]",
			max_len: "39",
			min_len: "",
			default_value: "",
		},
		record_interval: {
			name: "record_interval",
			rules: "trim|max_length[6]|integer|required",
			max_len: "6",
			min_len: "",
			default_value: "600",
		},
		device_type_id: {
			name: "device_type_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		upload_interval: {
			name: "upload_interval",
			rules: "trim|max_length[6]|integer|required",
			max_len: "6",
			min_len: "",
			default_value: "2",
		},
		power_mode: {
			name: "power_mode",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "1",
		},
		warranty_period: {
			name: "warranty_period",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "1",
		},
		last_record_date: {
			name: "last_record_date",
			rules: "trim",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		purchase_date: {
			name: "purchase_date",
			rules: "trim",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		battery: {
			name: "battery",
			rules: "trim|max_length[7]|decimal",
			max_len: "6",
			min_len: "",
			default_value: "",
		},
		signal_quality: {
			name: "signal_quality",
			rules: "trim|max_length[2]|integer|required",
			max_len: "2",
			min_len: "",
			default_value: "",
		},
		queued_records: {
			name: "queued_records",
			rules: "trim|max_length[8]|integer|required",
			max_len: "8",
			min_len: "",
			default_value: "",
		},
		command: {
			name: "command",
			rules: "trim|max_length[2]|integer|required",
			max_len: "2",
			min_len: "",
			default_value: "",
		},
		status: {
			name: "status",
			rules: "trim|max_length[10]|required",
			max_len: "10",
			min_len: "",
			default_value: "normal",
		},
		notes: {
			name: "notes",
			rules: "trim",
			max_len: "16777215",
			min_len: "",
			default_value: "",
		},
		import_id: {
			name: "import_id",
			rules: "trim|max_length[15]|integer",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		temperature_metric: {
			name: "temperature_metric",
			rules: "trim|max_length[7]|decimal",
			max_len: "6",
			min_len: "",
			default_value: "",
		},
		surge_protection: {
			name: "surge_protection",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
		temperature_low_threshold: {
			name: "temperature_low_threshold",
			rules: "trim|max_length[5]|decimal|less_than[devices.temperature_high_threshold]",
			max_len: "4",
			min_len: "",
			default_value: "",
		},
		temperature_high_threshold: {
			name: "temperature_high_threshold",
			rules: "trim|max_length[5]|decimal|greater_than[devices.temperature_low_threshold]",
			max_len: "4",
			min_len: "",
			default_value: "",
		},
		device_start: {
			name: "device_start",
			rules: "trim|integer|required",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		device_end: {
			name: "device_end",
			rules: "trim|integer|required",
			max_len: "",
			min_len: "",
			default_value: "",
		},
	},
	rules_iot_device_port_tank_metric: {
		device_ports_id: {
			name: "device_ports_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		def_liters: {
			name: "def_liters",
			rules: "trim|max_length[16]|decimal|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		metric_diameter: {
			name: "metric_diameter",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		metric_height: {
			name: "metric_height",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		metric_width: {
			name: "metric_width",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		metric_length: {
			name: "metric_length",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		sensor_offset: {
			name: "sensor_offset",
			rules: "trim|max_length[8]|decimal|cant_equal_zero|required",
			max_len: "8",
			min_len: "",
			default_value: "",
		},
		template: {
			name: "template",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
	},
	rules_iot_device_port_tank_imperial: {
		device_ports_id: {
			name: "device_ports_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		def_us_gallons: {
			name: "def_us_gallons",
			rules: "trim|max_length[16]|decimal|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		imperial_diameter: {
			name: "imperial_diameter",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		imperial_height: {
			name: "imperial_height",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		imperial_width: {
			name: "imperial_width",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		imperial_length: {
			name: "imperial_length",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "",
		},
		imperial_sensor_offset: {
			name: "sensor_offset",
			rules: "trim|max_length[8]|decimal|cant_equal_zero|required",
			max_len: "8",
			min_len: "",
			default_value: "",
		},
		template: {
			name: "template",
			rules: "trim|max_length[1]|integer|required",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
	},
};

// getters
const getters = {
	devices: (state) => {
		return state.devices;
	},
};

// actions
const actions = {
	async fetchDevices({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getDevices({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "page",
						with: response.data.page,
					});

					if (body.connection_status && body.connection_status == "offline") {
						commit("mutate", {
							property: "offline_devices_page",
							with: response.data.page,
						});
					}

					if (body.has_alerts && body.has_alerts == 1) {
						commit("mutate", {
							property: "device_alerts_page",
							with: response.data.page,
						});
					}
				}

				if (body.options) {
					commit("mutate", {
						property: "device_options",
						with: response.data.devices,
					});
				} else {
					commit("mutate", {
						property: "devices",
						with: response.data.devices,
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
	async fetchDevice({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await getDevice(payload.id);

			if (typeof response !== "undefined" && response.data) {
				commit("mutate", {
					property: "selectedDevice",
					with: response.data.device,
				});
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async printDevice({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await printDevice(payload.id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch print response error");
				return;
			}
		} catch (error) {
			console.log("print error");
			return;
		}
	},
	async saveDevice({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			if (typeof body["device_id"] === "undefined" || body["device_id"] == null || body["device_id"] == "") {
				delete body["device_id"];
				response = await createDevices({ body: body, headers: config.headers });
			} else {
				let device_id = body["device_id"];
				delete body["device_id"];
				response = await updateDevices({ body: body, headers: config.headers }, device_id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async deleteDevice({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await deleteDevices(payload.id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("delete response error");
				return;
			}
		} catch (error) {
			console.log("delete error");
			return;
		}
	},
	async fetchMobileProviders({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getMobileProviders({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {

				if (body.options) {
					commit("mutate", {
						property: "mobile_provider_options",
						with: response.data.mobile_providers,
					});
				} else {
					commit("mutate", {
						property: "mobile_providers",
						with: response.data.mobile_providers,
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
	async fetchDeviceTypes({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getDeviceTypes({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				commit("mutate", {
					property: "device_types",
					with: response.data.iot_device_types,
				});

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch all error");
			return;
		}
	},
	async fetchSignalStrengthGraph({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getSignalStrengthGraph({ id: payload.id, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch all error");
			return;
		}
	},
	async fetchTemperatureGraph({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getTemperatureGraph({ id: payload.id, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch all error");
			return;
		}
	},
	async fetchPortHistoryGraph({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await getPortHistoryGraph(body.device_id, body.port_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async fetchBatteryGraph({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await getBatteryGraph(body);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch single error");
			return;
		}
	},
	async addDeviceTag({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			if (body.type == "existing") {
				response = await attachDeviceTag(body.device_id, body.tags);
			} else if (body.type == "new") {
				response = await attachNewDeviceTag(payload, body.device_id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch single error");
			return;
		}
	},
	async removeDeviceTag({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await deleteDeviceTag(body.device_id, body.tag_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async saveDeviceBulk({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await createDeviceBulk(payload);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch single error");
			return;
		}
	},
	async reproviseDevice({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await reprovisionDevice(body.device_id);
			if (typeof response !== "undefined" && response.status == 200) {
				return response;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("fetch single error");
			return;
		}
	},
	async saveDevicePort({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			if (typeof body["device_ports_id"] === "undefined" || body["device_ports_id"] == null || body["device_ports_id"] == "") {
				let device_id = payload["device_id"];
				delete body["device_id"];
				response = await createDevicePort({ body: body, headers: config.headers }, device_id);
			} else {
				let device_id = payload["device_id"];
				delete body["device_id"];
				response = await updateDevicePort({ body: body, headers: config.headers }, device_id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async saveDevicePortTank({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			if (typeof body["id"] === "undefined" || body["id"] == null || body["id"] == "") {
				response = await createDevicePortTank({ body: body, headers: config.headers });
			} else {
				let id = body["id"];
				delete body["id"];
				response = await updateDevicePortTank({ body: body, headers: config.headers }, id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async removeDevicePortTank({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await deleteDevicePortTank(payload.id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async removeDevicePort({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await deleteDevicePort(payload.port_id, payload.device_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async saveProductMove({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			let device_id = body["device_id"];
			delete body["device_id"];
			response = await createProductMove({ body: body, headers: config.headers }, device_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log(error);
			console.log("save error");
			return;
		}
	},
	async fetchLT14DeviceLogs({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await getLT14DeviceLogs(body.device_id);

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "lt14_device_log_page",
						with: response.data.page,
					});
				}
				commit("mutate", {
					property: "lt14_device_logs",
					with: response.data.device_logs,
				});
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async fetchDeviceUsers({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await getDeviceUsers(body.device_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async fetchDevicesForMap({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getDevicesForMap({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			console.log(error);
			return;
		}
	},
	async fetchTankManufacturerSpecs({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};
			response = await getTankManufacturerSpecs(payload.id, payload);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
};

// mutations
const mutations = {
	mutate(state, payload) {
		state[payload.property] = payload.with;
	},
	mutateUpdateDashboardOfflineDevices(state, payload) {
		state.dashboard_offline_devices_page_num = payload.page_num;
	},
	mutateUpdateDashboardDeviceAlerts(state, payload) {
		state.dashboard_device_alerts_page_num = payload.page_num;
	},
	resetDevicesStore(state) {
		state.page = {};
		state.offline_devices_page = {};
		state.device_alerts_page = {};
		state.form = {};
		state.devices = [];
		state.device_types = [];
		state.device_options = [];
		state.device_alerts = [];
		state.offline_devices = [];
		state.lt14_device_logs = [];
		state.selectedDevice = {
			device_id: null,
			company_id: "",
			device_date: "",
			reference_number: "",
			status_id: "",
			billing_address_id: "",
			shipping_address_id: "",
			comments: "",
			device_details: [],
		};
		state.devices_filter = {
			search: "",
			status: "active",
			company_id: null,
			device_type_id: null,
			tags: [],
			page_size: 0,
			page_num: 0,
			connection_status: "",
		};
		state.dashboard_offline_devices_page_num = 1;
		state.dashboard_device_alerts_page_num = 1;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
